export default [

     {
          path: '/data-asset',
          name: 'DataAsset',
          component: () => import("@/views/Page/DataAsset/DataAsset.vue"),
           meta: {
               title: '#Default# | DataAsset',
          },
     }
];